export default __webpack_public_path__ + "static/media/227.c6a63ce6.jpg";